const ButtonsBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g>
      <rect x="1" y="1" width="22" height="8" fill="#ffd400" />
      <path d="M22,2V8H2V2H22m2-2H0V10H24V0Z" fill="#333" />
    </g>
    <g>
      <rect x="4" y="4" width="16" height="2" fill="#ffd400" />
      <polygon points="20 4 4 4 4 6 20 6 20 4 20 4" fill="#333" />
    </g>
    <g>
      <rect x="1" y="15" width="22" height="8" fill="#ffd400" />
      <path d="M22,16v6H2V16H22m2-2H0V24H24V14Z" fill="#333" />
    </g>
    <g>
      <rect x="4" y="18" width="16" height="2" fill="#ffd400" />
      <polygon points="20 18 4 18 4 20 20 20 20 18 20 18" fill="#333" />
    </g>
  </svg>
);

export default ButtonsBlockIcon;
